import { isDefined } from "@clipboard-health/util-ts";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics/events";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { useRef } from "react";

import { PageWrapper } from "../../../../components/PageWrapper";
import { StickyScrollPageHeader } from "../../../../components/StickyScrollPageHeader";
import { DocumentDetailsSection } from "../../DetailsSection";
import { DocumentUploadFooter } from "../../Footer";
import { DocumentDetailsMetadata } from "../../Metadata";
import { DocumentDetailsRequiredBySection } from "../../RequiredBySection/Section";
import { DocumentPageScrollWrapper } from "../../ScrollWrapper";
import { useDocumentDetailsActions } from "../../useDocumentDetailsActions";
import { useRequirementDetailsContext } from "../../useRequirementDetailsContext";
import { useRequirementPrerequisiteActions } from "../../useRequirementPrerequisiteActions";
import { TbTestWithAppointmentStatusCard } from "./StatusCard";

export function DocumentDetailsTbTestWithAppointmentPage() {
  const { requirement: workerRequirement } = useRequirementDetailsContext();
  const { requirementId } = workerRequirement;
  const scrollRef = useRef<HTMLDivElement>(null);
  const { status, requirement } = workerRequirement;
  const { name, disableWorkerUpload, instructions } = requirement?.attributes ?? {};

  const { uploadDocument, deleteDocument } = useDocumentDetailsActions();
  const { withPrerequisiteCheck, prerequisiteBottomSheet } = useRequirementPrerequisiteActions();

  useLogEffect(APP_V2_USER_EVENTS.VIEWED_IMPROVED_TB_TEST_PAGE, {
    requirement_id: requirementId,
    status,
  });

  return (
    <PageWrapper variant="tertiary">
      <StickyScrollPageHeader
        shouldWrapTitle
        title={name ?? ""}
        headerVariant="tertiary"
        scrollContainerRef={scrollRef}
      />

      <DocumentPageScrollWrapper ref={scrollRef}>
        <DocumentDetailsMetadata />
        <TbTestWithAppointmentStatusCard />
        {isDefined(instructions) && (
          <DocumentDetailsSection title="Instructions" description={instructions} />
        )}
        <DocumentDetailsRequiredBySection />
      </DocumentPageScrollWrapper>

      {disableWorkerUpload !== true && (
        <DocumentUploadFooter
          requirementId={requirementId}
          status={status}
          resubmissionDisabledFor={requirement?.attributes?.resubmissionDisabledFor}
          onUploadButtonClick={withPrerequisiteCheck(uploadDocument)}
          onDeleteButtonClick={deleteDocument}
        />
      )}
      {prerequisiteBottomSheet}
    </PageWrapper>
  );
}
